import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-grid-copy-button',
  templateUrl: './grid-copy-button.component.html',
  styleUrls: ['./grid-copy-button.component.css'],
})
export class GridCopyButtonComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;

  id!: string;

  constructor(private readonly toastrService: ToastrService) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.id = params.value ?? params.data.displayId ?? params.data.id;
  }

  refresh(params: ICellRendererParams) {
    return false;
  }

  copy() {
    navigator.clipboard.writeText(this.id);
    this.toastrService.success($localize`ID copié avec succès`);
  }
}
